import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

import CartIcon from '../CartIcon'

const Trigger = ({ onOpen }) => {
  const isVirtualStore = useSelector(state => state.currentRegion.virtualStore)
  const assetsInCartCount = useSelector(state => state.cart.itemsTotalCount)

  const handleOnClick = () => {
    onOpen()
  }

  return (
    <>
      <button
        className='vst-btn--transparent mini-cart__button-trigger'
        id='mini-cart'
        onClick={handleOnClick}
        type='button'
      >
        <CartIcon />
        {isVirtualStore
          && <span className='mini-cart__button-trigger__label'>
            <FormattedMessage id='header.my_cart' />
          </span>
        }
        <VisuallyHidden>
          {translate('carts.view_items_in_cart')}
          {' (' + assetsInCartCount + ')'}
        </VisuallyHidden>
      </button>
      <div aria-hidden='true' className='mini-cart__badge'>
        {assetsInCartCount}
      </div>
    </>
  )
}

export default Trigger

Trigger.propTypes = {
  onOpen: PropTypes.func.isRequired
}
